import { Routes, Route, Navigate } from "react-router-dom";
import { ClerkSignIn, ClerkSignUp } from "./screens/auth";
import ErrorBoundary from "./components/error-boundary";
import AuthErrorBoundary from "./components/auth-error-boundary";
import Home from "./screens/home";
import InsertSyllabi from "./screens/insert-syllabi";
import SelectSections from "./screens/select-sections";
import TimezoneSelection from "./screens/timezone-selection";
import ChooseSections from "./screens/choose-sections";
import AddCourseTimes from "./screens/add-course-times";
import SelectCalendar from "./screens/select-calendar";
import AddEvents from "./screens/add-events";
import EventsAdded from "./screens/events-added";
import NoEvents from "./screens/no-events";
import AccountSettings from "./screens/account-settings";
import Courses from "./screens/courses";
import UserProfilePage from "./screens/user-profile";
import { Loading } from "./screens/loading";
import { StreamingLoading } from "./screens/streaming-loading";
import OceanCalendar from "./screens/calendar";
import Console from "./screens/console";
import "./App.scss";
import Layout from "./components/layout";
import { SelectedFilesProvider } from "./hooks/use-selected-files";
import { SectionsProvider } from "./hooks/use-sections";
import { SidebarProvider } from "./contexts/sidebar-context";
import { TourProvider } from "./contexts/tour-context";
import OnboardingTour from "./components/onboarding-tour";
import AuthGate from "./components/auth-gate";
import WaitlistPage from "./screens/waitlist";
import WaitlistSuccess from "./screens/waitlist-success";
import { PrivacyPolicy, TermsOfService } from "./screens/info";

const App = () => {
  return (
    <ErrorBoundary>
      <AuthErrorBoundary>
        <SidebarProvider>
          <TourProvider>
            <OnboardingTour />
            <SectionsProvider>
              <SelectedFilesProvider>
                <Layout>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <AuthGate fallback={<Navigate to="/sign-in" replace />}>
                        <Home />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/sign-in/*"
                    element={<ClerkSignIn />}
                  />
                  <Route
                    path="/sign-up/*"
                    element={<ClerkSignUp />}
                  />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/waitlist" element={<WaitlistPage />} />
                  <Route path="/waitlist-success" element={<WaitlistSuccess />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route
                    path="/account-settings"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <AccountSettings />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/courses"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <Courses />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/calendar"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <OceanCalendar />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/console"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <Console />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/user-profile/*"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <UserProfilePage />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/upload"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <InsertSyllabi />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/select-sections"
                    element={
                      <AuthGate fallback={null}>
                        <SelectSections />
                      </AuthGate>
                    }
                  />
                  <Route
                      path="/timezone-selection"
                      element={
                        <AuthGate fallback={null}>
                          <TimezoneSelection />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/choose-sections"
                    element={
                      <AuthGate fallback={null}>
                        <ChooseSections />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/add-course-times"
                    element={
                      <AuthGate fallback={null}>
                        <AddCourseTimes />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/select-calendar"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <SelectCalendar />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/add-events/:calendar"
                    element={
                      <AuthGate fallback={<Navigate to="/" replace />}>
                        <AddEvents />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/events-added"
                    element={
                      <AuthGate fallback={null}>
                        <EventsAdded />
                      </AuthGate>
                    }
                  />
                  <Route
                    path="/no-events"
                    element={
                      <AuthGate fallback={null}>
                        <NoEvents />
                      </AuthGate>
                    }
                  />
                  <Route path="/loading" element={<Loading />} />
                  <Route path="/streaming-loading" element={<StreamingLoading />} />
                </Routes>
                </Layout>
              </SelectedFilesProvider>
            </SectionsProvider>
          </TourProvider>
        </SidebarProvider>
      </AuthErrorBoundary>
    </ErrorBoundary>
  );
};

export default App;
